import { RefBool } from "@tblabs/truffle";
import { Step } from "../Steps/Step/Step";
import { ContextMenu, Menu } from "./Utils/Menu";
import { Router } from "../Services/Router";
import { AgentsProvider } from "../Services/AgentsProvider";


export class AdminStepPrinterMenu extends ContextMenu
{
    constructor(_router: Router, _agents: AgentsProvider, step: Step<any>, openInlineEditor: RefBool, refresh?: () => void)
    {
        super({
            "👁️ Pokaż zamówienie": () =>
            {
                _router.GoToOrderView(step.Order.Id);
            },
            "📝 Edytuj zamówienie": () =>
            {
                _router.GoToOrderEdit(step.Order.Id);
            },
            "👓 Widok klienta": () =>
            {
                _router.GoToCustomerView(step.Order.Id);
            },
            "☢️ Resetuj krok": () =>
            {
                step.ResetState();
                refresh?.();
            },
            "🎛️ Edycja kroku": () =>
            {
                openInlineEditor.Toggle();
            },
            "🕵️ Przypisz agenta": () =>
            {
                this.Append(
                    new Menu(this.AgentsList(_agents, step, refresh))
                )
            },
        })

        this.PositionAbsolute().Top(8).Right(8);
    }

    private AgentsList(_agents: AgentsProvider, step: Step<any>, refresh: (() => void) | undefined)
    {
        const agentsToAssignMenu: Record<string, () => void> = _agents.All.reduce((acc, x) => ({
            ...acc, [x.Icon + " " + x.Name]: () =>
            {
                step.Data.AssignedAgentId.value = x.Id;
                step.CallOnChange();
                refresh?.();
            }
        }), {});

        if (step.Data.AssignedAgentId.value)
        {
            agentsToAssignMenu["(nie przypisany)"] = () =>
            {
                step.Data.AssignedAgentId.value = "";
                step.CallOnChange();
                refresh?.();
            };
        }

        return agentsToAssignMenu;
    }
}
